"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var lodash_1 = require("lodash");
var I18n = require("i18n-js");
var react_apollo_1 = require("react-apollo");
var bind_1 = require("../bind");
var selectable_credit_card_list_query_1 = require("./selectable_credit_card_list_query");
var local_gql_1 = require("../schemas/local.gql");
var url_helpers_1 = require("../components/shared/url_helpers");
var credit_card_html_form_1 = require("./credit_card_html_form");
var selectable_credit_card_1 = require("./selectable_credit_card");
var selectable_credit_card_list_placeholder_1 = require("./selectable_credit_card_list_placeholder");
var selectable_credit_card_list_error_1 = require("./selectable_credit_card_list_error");
function primaryCreditCard(creditCards) {
    return creditCards.find(function (cc) { return cc.primaryForCheckout; });
}
function allCardsPrimaryFirst(creditCards) {
    var allCards = lodash_1.compact([
        primaryCreditCard(creditCards),
    ]).concat(creditCards);
    return lodash_1.uniqBy(allCards, function (cc) { return cc.id; });
}
exports.allCardsPrimaryFirst = allCardsPrimaryFirst;
function getCheckoutId(location) {
    var pathname = location.pathname;
    var parts = CHECKOUT_ID_MATCHER.exec(pathname);
    if (!parts || parts.length !== 2) {
        throw (new Error("could not parse checkout id out of url " + pathname));
    }
    return parts[1]; // RCP-USD-direct_checkout
}
function cardEditPath(location, creditCard) {
    var checkoutId = getCheckoutId(location);
    return url_helpers_1.default.editDirectCheckoutCreditCardPath(checkoutId, creditCard.id);
}
function selectCard(_, _a, _b) {
    var id = _a.id;
    var client = _b.client;
    var updated = updateQueryDataInline(client.readQuery({ query: selectable_credit_card_list_query_1.QUERY }), id);
    client.writeQuery({ query: selectable_credit_card_list_query_1.QUERY, data: updated });
    return null;
}
exports.selectCard = selectCard;
function updateQueryDataInline(originalQueryData, id) {
    var updated = tslib_1.__assign({}, originalQueryData);
    updated.me.creditCards = originalQueryData.me.creditCards.map(function (cc) {
        if (cc.id === id) {
            return tslib_1.__assign(tslib_1.__assign({}, cc), { isSelected: true });
        }
        return tslib_1.__assign(tslib_1.__assign({}, cc), { isSelected: false });
    });
    return updated;
}
exports.updateQueryDataInline = updateQueryDataInline;
exports.resolvers = {
    core_apimessages_CreditCard: {
        isSelected: function (cc) {
            return cc.primaryForCheckout;
        },
    },
};
var CHECKOUT_ID_MATCHER = new RegExp(/multi-checkout\/(.*)\/direct/);
var SelectableCreditCardListContainer = /** @class */ (function (_super) {
    tslib_1.__extends(SelectableCreditCardListContainer, _super);
    function SelectableCreditCardListContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isCreatingCard: false,
        };
        return _this;
    }
    SelectableCreditCardListContainer.prototype.updateSelectedCard = function (id) {
        this.props.mutate({ variables: { id: id } });
        this.setState({ isCreatingCard: !id }); // if id is present, close the form
    };
    SelectableCreditCardListContainer.prototype.renderNewCreditCardForm = function () {
        if (!this.state.isCreatingCard) {
            return null;
        }
        return (React.createElement("div", { className: "module" },
            React.createElement("h3", { className: "heading-3 mb-half" }, I18n.t('discovery.selectableCreditCardList.creditCard')),
            React.createElement("p", { className: "small muted mb-1" },
                React.createElement("span", { className: "fa fa-lock mr-space" }),
                I18n.t('discovery.selectableCreditCardList.processedWithEncryption')),
            React.createElement(credit_card_html_form_1.default, null)));
    };
    SelectableCreditCardListContainer.prototype.renderBillingAddress = function () {
        if (!this.state.isCreatingCard || !this.props.checkoutBillingAddressForm) {
            return null;
        }
        return this.props.checkoutBillingAddressForm;
    };
    SelectableCreditCardListContainer.prototype.render = function () {
        var _this = this;
        if (this.props.data.loading)
            return (React.createElement(selectable_credit_card_list_placeholder_1.default, null));
        if (this.props.data.error)
            return (React.createElement(selectable_credit_card_list_error_1.default, null));
        if (this.props.data.me.creditCards.length === 0) {
            throw (new Error('attempting to render card list, but no cards on file were found'));
        }
        var creditCardsInOrder = allCardsPrimaryFirst(this.props.data.me.creditCards);
        return (React.createElement("div", null,
            React.createElement("div", { className: "module" },
                React.createElement("h3", { className: "heading-3 mb-1" }, I18n.t('discovery.selectableCreditCardList.chooseACard')),
                React.createElement("ul", null,
                    creditCardsInOrder.map(function (cc) {
                        return (React.createElement(selectable_credit_card_1.default, { key: cc.id, creditCard: cc, onClick: function () { return _this.updateSelectedCard(cc.id); }, editPath: cardEditPath(_this.props.location, cc) }));
                    }),
                    React.createElement("li", null,
                        React.createElement("input", { type: "radio", name: "payment[credit_card_id]", id: "payment_credit_card_id_", onClick: function () { return _this.updateSelectedCard(''); }, checked: this.state.isCreatingCard, value: "", className: "boxed-list__toggle" }),
                        React.createElement("label", { className: "boxed-list__item boxed-list__item--selectable", htmlFor: "payment_credit_card_id_" }, I18n.t('discovery.selectableCreditCardList.addNewCard'))))),
            this.renderNewCreditCardForm(),
            this.renderBillingAddress()));
    };
    SelectableCreditCardListContainer.defaultProps = {
        location: window.location,
    };
    tslib_1.__decorate([
        bind_1.default
    ], SelectableCreditCardListContainer.prototype, "updateSelectedCard", null);
    return SelectableCreditCardListContainer;
}(React.Component));
exports.SelectableCreditCardListContainer = SelectableCreditCardListContainer;
exports.default = react_apollo_1.compose(selectable_credit_card_list_query_1.connectSelectableCreditCardListQuery, react_apollo_1.graphql(local_gql_1.SelectCheckoutCreditCard))(SelectableCreditCardListContainer);
//# sourceMappingURL=selectable_credit_card_list_container.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/selectable_credit_card_list_container.js
// module id = cTud
// module chunks = 20 21 22